import $http from "./http-index";

/**
* @description: 示例

// form-data 请求方式
export const 接口名 = data => {
    return $http.post("接口地址", data);
};

// json 请求方式
export const 接口名 = data => {
    return $http.post("接口地址", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
*/
export const getDataAll = data => {
    return $http.post("/realData/getDataAll", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
export const getCharge = data => {
    return $http.post("/charge/getCharge", data);
};
